import React, { useEffect } from 'react';

const SCRIPT_ID = 'vatican-news-widget-script';
const SCRIPT_SRC = 'https://www.vaticannews.va/widget.js';

const VaticanNewsWidget = () => {
  useEffect(() => {
    const existingScript = document.getElementById(SCRIPT_ID);
    if (existingScript) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);
  }, []);

  return (
    <vaticannews-widget 
      lang="es" 
      fontSize="14" 
      carouselVideoAuto="true" 
      carouselVideoTime="medium">
    </vaticannews-widget>
  );
};

export default VaticanNewsWidget;